import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, subscriptions: data, error, message, updated, isLoadingUpdate,
  } = state.subscription;
  return {
    isLoading,
    data,
    error,
    message,
    updated,
    isLoadingUpdate,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
